import AllocatedControlsImplGuidanceNotesModal from "./AllocatedControlsImplGuidanceNotesModal";

export default AllocatedControlsImplGuidanceNotesModal;
